import createIconSetFromFontello from "@react-native-vector-icons/fontello";
import fontelloConfig from "./icon-font.json";

export const PearsonIcons = createIconSetFromFontello(
	fontelloConfig,
	"pearsonicons",
	"pearsonicons.ttf",
);
